import React, { useState, useRef, useCallback } from 'react';
import Swal from "sweetalert2/dist/sweetalert2.js";
import Preloader from '../../../../GeneralComponents/LoadingComponen';

const Index = () => {
    const [tenantSearch, setTenantSearch] = useState("");
    const [tenantOptions, setTenantOptions] = useState([]);
    const [selectedTenant, setSelectedTenant] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [data, setData] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const debounceRef = useRef(null);

    const token = document.querySelector("[name='csrf-token']").content;

    const searchTenants = useCallback((query) => {
        if (query.length < 2) {
            setTenantOptions([]);
            setShowDropdown(false);
            return;
        }

        if (debounceRef.current) clearTimeout(debounceRef.current);

        debounceRef.current = setTimeout(() => {
            fetch(`/settings/search_recovery_tenants?query=${encodeURIComponent(query)}`, {
                method: 'GET',
                headers: { "X-CSRF-Token": token, "Content-Type": "application/json" }
            })
            .then(response => response.json())
            .then(response => {
                setTenantOptions(response.data);
                setShowDropdown(response.data.length > 0);
            });
        }, 300);
    }, []);

    const handleTenantInputChange = (e) => {
        const value = e.target.value;
        setTenantSearch(value);
        setSelectedTenant(null);
        searchTenants(value);
    }

    const handleSelectTenant = (tenant) => {
        setSelectedTenant(tenant);
        setTenantSearch(tenant.label);
        setShowDropdown(false);
        loadFormats(tenant.value);
    }

    const loadFormats = (tenantId) => {
        setIsLoaded(true);
        setHasSearched(true);

        fetch(`/settings/get_recovery_formats?tenant_id=${tenantId}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": token, "Content-Type": "application/json" }
        })
        .then(response => response.json())
        .then(response => {
            setData(response.data);
            setIsLoaded(false);
        });
    }

    const handleRestore = (formato) => {
        Swal.fire({
            title: "Restaurar formato?",
            text: `Se restaurara el formato: ${formato.name} (ID: ${formato.id})`,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, restaurar",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.value) {
                fetch(`/settings/restore_format/${formato.id}`, {
                    method: 'POST',
                    headers: { "X-CSRF-Token": token, "Content-Type": "application/json" }
                })
                .then(response => response.json())
                .then(response => {
                    if (response.type === "success") {
                        setData(data.filter(item => item.id !== formato.id));
                        Swal.fire({ position: "center", type: "success", title: response.success, showConfirmButton: false, timer: 1500 });
                    }
                });
            }
        });
    }

    const dateTime = (fecha) => {
        if (!fecha) return "N/A";
        var d = new Date(fecha);
        var months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        return months[d.getMonth()] + " " + d.getDate() + " del " + d.getFullYear() + " / " + d.getHours() + ":" + (d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes());
    }

    return (
        <React.Fragment>
            <div className="row mb-3">
                <div className="col-md-5" style={{ position: 'relative' }}>
                    <label>Buscar Tenant</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Escriba al menos 2 letras..."
                        value={tenantSearch}
                        onChange={handleTenantInputChange}
                        onFocus={() => { if (tenantOptions.length > 0) setShowDropdown(true); }}
                        onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                    />
                    {showDropdown && (
                        <div style={{
                            position: 'absolute', zIndex: 1000, width: 'calc(100% - 30px)',
                            maxHeight: '250px', overflowY: 'auto', backgroundColor: '#fff',
                            border: '1px solid #ced4da', borderRadius: '0 0 4px 4px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                        }}>
                            {tenantOptions.map(option => (
                                <div
                                    key={option.value}
                                    style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                                    onMouseDown={() => handleSelectTenant(option)}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#fff'}
                                >
                                    {option.label}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                {selectedTenant && (
                    <div className="col-md-4 d-flex align-items-end">
                        <span className="badge badge-info" style={{ fontSize: '14px', padding: '8px 12px' }}>
                            <i className="fas fa-building mr-1"></i> {selectedTenant.label}
                        </span>
                    </div>
                )}
            </div>

            {isLoaded && <Preloader />}

            {!isLoaded && hasSearched && (
                <React.Fragment>
                    {data.length >= 1 ? (
                        <table className="table table-hover table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nombre</th>
                                    <th>Preguntas</th>
                                    <th>Registros</th>
                                    <th>Eliminado por</th>
                                    <th>Fecha eliminacion</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map(formato => (
                                    <tr key={formato.id}>
                                        <td>{formato.id}</td>
                                        <td>{formato.name}</td>
                                        <td>{formato.questions_count}</td>
                                        <td>{formato.surveys_count}</td>
                                        <td>{formato.user_delete ? formato.user_delete.name : "N/A"}</td>
                                        <td>{dateTime(formato.date_delete)}</td>
                                        <td>
                                            <button
                                                className="btn btn-shadow btn-sm btn-success"
                                                onClick={() => handleRestore(formato)}
                                            >
                                                <i className="fas fa-undo"></i> Restaurar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className="card">
                            <div className="card-body text-center">
                                <h5>No hay formatos eliminados para este tenant</h5>
                            </div>
                        </div>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default Index;
